export interface ReconnectConfig {
  baseDelayMs: number;
  maxDelayMs: number;
  maxAttempts: number;
  jitterFactor: number; // 0-1 for randomization
}

export const DEFAULT_RECONNECT_CONFIG: ReconnectConfig = {
  baseDelayMs: 1000, // 1 second initial delay
  maxDelayMs: 30000, // 30 second max delay
  maxAttempts: 5,
  jitterFactor: 0.3, // +/- 30% randomization
};

/**
 * Calculate exponential backoff delay with jitter
 * Formula: min(baseDelay * 2^attempt, maxDelay) + random jitter
 */
export function calculateBackoffDelay(
  attempt: number,
  config: ReconnectConfig = DEFAULT_RECONNECT_CONFIG
): number {
  // Exponential backoff: baseDelay * 2^attempt
  const exponentialDelay = config.baseDelayMs * Math.pow(2, attempt);
  const cappedDelay = Math.min(exponentialDelay, config.maxDelayMs);

  // Add jitter to prevent thundering herd problem
  const jitter = cappedDelay * config.jitterFactor * (Math.random() * 2 - 1);

  return Math.round(cappedDelay + jitter);
}

/**
 * Check if reconnection should be attempted based on current attempt count
 */
export function shouldAttemptReconnect(
  attempt: number,
  config: ReconnectConfig = DEFAULT_RECONNECT_CONFIG
): boolean {
  return attempt < config.maxAttempts;
}
